import { useSelector } from 'react-redux';
import { selectBuilder, selectOtherProjects, selectProjectId } from '../../selectors';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { OtherProjectsCarousel, OtherProjectsList } from '../../components/OtherProjects';
import { useAnalytics } from './hooks';

export const OtherProjectsContainer = () => {
  const otherProjects = useSelector(selectOtherProjects);
  const company = useSelector(selectBuilder);
  const projectId = useSelector(selectProjectId);
  const deviceType = useDeviceType();
  const { trackBuilderLinkClick, trackProjectLinkClick, trackProjectsListChange } = useAnalytics({
    builderId: company.id,
    projectId,
    otherProjects,
  });

  if (!otherProjects.length) {
    return null;
  }

  const OtherProjectsComponent = deviceType === 'desktop' ? OtherProjectsCarousel : OtherProjectsList;

  return (
    <OtherProjectsComponent
      company={company}
      items={otherProjects}
      onBuilderLinkClick={trackBuilderLinkClick}
      onProjectLinkClick={trackProjectLinkClick}
      onProjectsListChange={trackProjectsListChange}
    />
  );
};
